
<script>
    export default {
        methods: {
          $formatSize(bytes) {
            const sizeInMB = bytes / 1048576;
            return sizeInMB.toFixed(2); // Limita a 2 decimales
          },
          $mesActual(){
            const d = new Date();
            let month = d.getMonth();
            return month+1;
          },
          $cargarCajas(success,ff){
            this.axios.get(process.env.VUE_APP_BACKEND + "/api/cajas")
                .then((response)=>{
                  success(response);
                })
                .catch(()=>{
                  this.$swal('Cuidado',"Error cargando las cajas",'warning');
                })
                .finally(()=>
                {
                  ff();
                });

          },
          $cargarClasificadoresPorExpediente(expediente_id,success,ff){
            this.axios.get(process.env.VUE_APP_BACKEND + "/api/expedientes/clasificadores/"+expediente_id)
                .then((response)=>{
                  success(response);
                })
                .catch(()=>{
                  this.$swal('Cuidado',"Error cargando las cajas",'warning');
                })
                .finally(()=>
                {
                  ff();
                });

          },
          $cargarClasificadores(success,ff){
            this.axios.get(process.env.VUE_APP_BACKEND + "/api/clasificadores")
                .then((response)=>{
                  success(response);
                })
                .catch(()=>{
                  this.$swal('Cuidado',"Error cargando las cajas",'warning');
                })
                .finally(()=>
                {
                  ff();
                });

          },
          $cargarMetas(expediente_id,success,ff){
            this.axios.get(process.env.VUE_APP_BACKEND + "/api/metas/lista/"+expediente_id)
                .then((response)=>{
                  success(response);
                })
                .catch(()=>{
                  this.$swal('Cuidado',"Error cargando las metas",'warning');
                })
                .finally(()=>
                {
                  ff();
                });

          },
          $cargarExpedientes(success,error){
            this.axios.get(process.env.VUE_APP_BACKEND + "/api/expedientes")
                .then((response)=>{
                  success(response);
                })
                .catch(()=>{
                  this.$swal('Cuidado',"Error cargando los expedientes",'warning');
                })
                .finally(()=>
                {
                  error();
                });

          },
          $cargarUnidadesMedida(success,error,ff){
            this.axios.get(process.env.VUE_APP_BACKEND + "/api/unidades-medida")
                .then((response)=>{
                  success(response);
                })
                .catch(()=>{
                  this.$swal('Cuidado',"Error cargando las unidades de medida",'warning');
                  error();
                })
                .finally(()=>
                {
                  ff();
                });

          },
          $isNumeric(str) {
            if (typeof str != "string") return false // we only process strings!
            return !isNaN(str) && // use type coercion to parse the _entirety_ of the string (`parseFloat` alone does not do this)...
                !isNaN(parseFloat(str)) // ...and ensure strings of whitespace fail
          },
          $buscarDNI(dni,success,ff){
              this.axios.get("https://facturaglobal.pe/api/busqueda/dni/"+dni)
              .then((response)=>
                  {
                      success(response);
                  }
              )
              .finally(()=>
                  {
                      ff();
                  }
             )
          },
          $buscarPorRUC(ruc,success,error){
            this.axios.get("https://facturaglobal.pe/api/busqueda/ruc/"+ruc)
                .then((response)=>
                    {
                      success(response);
                    }
                )
                .finally(()=>
                    {
                      error();
                    }
                )
          },
          $matchKey(array, id)
          {
              for (let el of array) {
                  if (el.id === id) {
                      return el;
                  }
              }
          },
          $formatDate(value){
              if (value) {
                  return this.$moment(String(value)).format('DD/MM/YYYY hh:mm')
              }
          },
          $matchElement(array,key, valor){
              for (let el of array) {
                  if (el[key] === valor) {
                      return el;
                  }
              }

          },
          $downloadFile(response, filename,type) {
            // It is necessary to create a new blob object with mime-type explicitly set
            // otherwise only Chrome works like it should
            var newBlob = new Blob([response.data], {type: type});

            // IE doesn't allow using a blob object directly as link href
            // instead it is necessary to use msSaveOrOpenBlob
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              window.navigator.msSaveOrOpenBlob(newBlob);
              return
            }

            // For other browsers:
            // Create a link pointing to the ObjectURL containing the blob.
            const data = window.URL.createObjectURL(newBlob);
            var link = document.createElement('a');
            link.href = data;
            link.download = filename ;
            link.click();
            setTimeout(function () {
              // For Firefox it is necessary to delay revoking the ObjectURL
              window.URL.revokeObjectURL(data)
            }, 100)
          },

        },
    }
</script>

